import React from "react";
import {
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import "./index.css";
import { Button } from "../ui/button";
import useCustomPopover from "../CustomPopover/hooks/useCustomPopover";
import { SelectPageSizePopover } from "./components";

const Pagination = (props) => {
  const { currentPage, totalItems, pageSize, onPageChange, onPageSizeChange } =
    props;
  const { open, anchorEl, handleClose, handleClick } = useCustomPopover();
  const totalPages = Math.ceil(totalItems / pageSize);

  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        );
      }
    }
    return pages;
  };

  return (
    <div className="pagination-container">
      <div
        style={{
          display: "flex",
          gap: "1.5rem",
          alignItems: "center",
          color: "rgb(75 85 99)",
          fontSize: "14px",
          lineHeight: "1.25rem",
        }}
      >
        <div className="items-label text-md">
          Showing {(currentPage - 1) * pageSize + 1}-
          {Math.min(currentPage * pageSize, totalItems)} of {totalItems} results
        </div>
        <span className="text-md">Show:</span>
        <Button
          aria-describedby={open ? "simple-popover" : undefined}
          size="sm"
          variant="outline"
          className="!h-6 !text-[14px] !rounded-xl !px-5 !py-5 !flex items-center !justify-between !gap-[2rem] !text-gray-600 !hover:bg-accent !hover:text-accent-foreground !focus:outline-none !focus:ring-2 !focus:ring-ring !focus:ring-offset-2 transactions-select-button"
          onClick={(ev) => {
            ev.stopPropagation();
            handleClick(ev, "practices");
          }}
        >
          {pageSize} <ChevronDown className="w-4 h-4" />
        </Button>
      </div>

      <div className="flex items-center space-x-2">
        <button
          className={`pagination-button hover:bg-gray-100 disabled:hover:bg-transparent disabled:opacity-50`}
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
        >
          <ChevronsLeft size={16} />
        </button>
        <button
          className={`pagination-button hover:bg-gray-100 disabled:hover:bg-transparent disabled:opacity-50`}
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronLeft size={16} />
        </button>

        {getPageNumbers().map((page, index) =>
          page === "..." ? (
            <span key={index} className="text-md">
              ...
            </span>
          ) : (
            <button
              key={index}
              className={`pagination-button ${
                page === currentPage
                  ? "!bg-[#136c62] text-white"
                  : "hover:bg-gray-100"
              }`}
              onClick={() => onPageChange(Number(page))}
            >
              {page}
            </button>
          ),
        )}

        <button
          className={`pagination-button hover:bg-gray-100 disabled:hover:bg-transparent disabled:opacity-50`}
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <ChevronRight size={16} />
        </button>
        <button
          className={`pagination-button hover:bg-gray-100 disabled:hover:bg-transparent disabled:opacity-50`}
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          <ChevronsRight size={16} />
        </button>
      </div>

      <SelectPageSizePopover
        anchorEl={anchorEl}
        isPageSizeOpen={open}
        handleClose={handleClose}
        setPageSize={onPageSizeChange}
        pageSize={pageSize}
      />
    </div>
  );
};

export default Pagination;
